<script>

import UserTicketCard from "~/modules/user/components/UserTicketCard.vue";
import OwnerAskStatus from "~/modules/ask/components/OwnerAskStatus.vue";
import OwnerAskDropdown from "~/modules/ask/components/OwnerAskDropdown.vue";
import ResumeListItem from "~/modules/cart/components/ResumeListItem.vue";

export default {
  name: "CarouselTable",
  components: {ResumeListItem, OwnerAskDropdown, OwnerAskStatus, UserTicketCard},
  props: {
    defaultOrder: {
      type: Object,
      default () { return {}}
    },
    carousels: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    userStatusLabels () {
      return {
        1: this.$t('signup.step-1.statut.1'),
        2: this.$t('signup.step-1.statut.2'),
        3: this.$t('signup.step-1.statut.3'),
        4: this.$t('signup.step-1.statut.4'),
        5: this.$t('signup.step-1.statut.5'),
      }
    }
  },
  methods: {
    formatRentalTitle (title) {
      if (title && title.length > 27) {
        return title.substring(0, 27) + '...'
      } else {
        return title
      }
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleClick (id) {
      if (this.$refs['ActionSelect' + id]) {
        this.$refs['ActionSelect' + id].handleOpen()
      }
    },
    onCellClick (row, column) {
      if (column.property !== 'action') {
        this.$router.push({
          name: 'admin-carousel-edit',
          params: {
            id: row.id
          }
        })
      }
      // console.log('row click')
      // console.log(row)
      // console.log(column)
    },
    onRowClick (row) {
      // console.log('onclick row')
      // console.log(this.$events)
      // console.log(row)
      // window.location.href = '/user/location/' + row.id
    }
  }
}
</script>

<template>
  <el-table :data="carousels" style="width: 100%; " :table-layout="'auto'" :default-sort="defaultOrder" @cell-click="onCellClick" :row-class-name="tableRowClassName" class="pointer-row">
    <template #empty>
      <slot name="empty"></slot>
    </template>
    <el-table-column prop="locataire" label="Utilisateur" sortable="custom" min-width="210">
      <template #default="{row}">
        {{ row.title }}
      </template>
    </el-table-column >
    <el-table-column fixed="right" width="30">
      <template #default="scope">
        <el-dropdown trigger="click" :ref="'ActionSelect' + scope.row.id">
          <div class="dropdown">
            <button class="dropdown-edit-toogle" style="padding: 5px;" @click.stop="handleClick(scope.row.id)">
                <span class="icon-kit">
                  &#xe9a5
                </span>
            </button>
          </div>
          <template #dropdown>
          </template>
        </el-dropdown>
      </template>
    </el-table-column>
  </el-table>
</template>

<style lang="scss">
.el-table__row:nth-child(2n+1) {
  //--el-table-tr-bg-color: #0e84b5;
  .td.el-table__cell {
    //--el-table-tr-bg-color: #0e84b5;
  }
  /*background-color: #0e84b5;*/
}
.el-table__header-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--left, .el-table__header-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--right, .el-table__header-wrapper tr:nth-child(2n+1) , .el-table__header-wrapper tr:nth-child(2n+1), .el-table__body-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--left, .el-table__body-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--right, .el-table__body-wrapper tr:nth-child(2n+1) , .el-table__body-wrapper tr:nth-child(2n+1), .el-table__footer-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--left, .el-table__footer-wrapper tr:nth-child(2n+1) td.el-table-fixed-column--right, .el-table__footer-wrapper tr:nth-child(2n+1) , .el-table__footer-wrapper tr:nth-child(2n+1) {
  //--el-table-tr-bg-color: #0e84b5;
  //background: var(--el-table-tr-bg-color);
}
</style>
